// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_ga6Yv","banner":"banner_TlCve"};